<template>
  <v-form ref="form" @submit.prevent="add">
    <v-select
      v-model="category"
      :items="categories"
      label="Category"
      :rules="[required]"
    />
    <v-text-field v-model="name" :rules="[required]" label="Name" />
    <v-text-field
      v-model="phone"
      :rules="[required]"
      label="Phone"
      mask="phone"
    />
    <v-text-field
      v-model="email"
      type="email"
      :rules="[required]"
      label="Email"
    />
    <v-text-field
      v-model="insurance"
      :rules="[required]"
      label="Insurance Provider"
    />
    <v-menu
      ref="menu"
      v-model="isMenuOpen"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="expires"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <v-text-field
        slot="activator"
        label="Expiry Date"
        :value="expires | formatDate"
        readonly
        :rules="[required]"
        @focus="isMenuOpen = true"
      />
      <v-date-picker v-model="expires" no-title scrollable>
        <v-spacer />
        <v-btn flat color="primary" @click="isMenuOpen = false">
          Cancel
        </v-btn>
        <v-btn flat color="primary" @click="$refs.menu.save(expires)">
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-text-field
      v-model="website"
      :rules="[required]"
      label="Website"
      prefix="http://"
    />
    <v-layout justify-space-around>
      <v-btn @click="$router.go(-1)">
        Cancel
      </v-btn>
      <v-btn type="submit" color="primary">
        Add vendor
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
import { db, getUid } from '@/plugins/firebase';
import { pick } from 'lodash-es';
import { required } from '@/util';
import dayjs from 'dayjs';

export default {
  name: 'AddVendor',
  filters: {
    formatDate: date => date && dayjs(date).format('MMMM D, YYYY'),
  },
  data: () => ({
    isMenuOpen: false,
    expires: null,
    category: null,
    categories: ['Electrical', 'Plumbing'],
    name: null,
    phone: null,
    email: null,
    insurance: null,
    website: null,
  }),
  methods: {
    required,
    async add() {
      if (!this.$refs.form.validate()) return;
      await db
        .collection('users')
        .doc(getUid())
        .collection('vendors')
        .doc()
        .set({
          ...pick(this.$data, [
            'category',
            'name',
            'phone',
            'email',
            'insurance',
            'website',
          ]),
          expires: dayjs(this.expires).valueOf(),
        });
      this.$router.push('maintenance');
    },
  },
};
</script>

<style></style>
